<!-- メイン領域-->
<mat-drawer-container class="main-container" autosize>
  <!-- 一覧画面表示領域-->
  <div class="details-layout">
    <p-table
      #table
      [value]="searchResultsList"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)"
      [rowsPerPageOptions]="[10, 50, 100]"
      [(first)]="pages"
      styleClass="p-datatable-striped master-datatable"
      selectionMode="single"
    >
      <ng-template pTemplate="caption">
        <div class="p-d-flex p-jc-between">
          <div class="p-d-flex">
            <!-- 検索画面表示-->
            <button
              type="button"
              pButton
              icon="pi pi-search"
              (click)="search.toggle()"
              class="p-mr-2"
              pTooltip="検索"
              tooltipPosition="bottom"
            ></button>

            <!-- 新規登録表示-->
            <button
              type="button"
              pButton
              icon="pi pi-plus"
              (click)="new()"
              class="p-mr-2"
              pTooltip="新規"
              tooltipPosition="bottom"
            ></button>
          </div>
          <div>
            <!-- 全件csv出力-->
            <button
              type="button"
              pButton
              icon="pi pi-file-o"
              (click)="exportCSV()"
              class="p-mr-2"
              pTooltip="全件CSV"
              tooltipPosition="bottom"
            ></button>
          </div>
        </div>
      </ng-template>

      <!-- 一覧画面ヘッダー表示-->
      <ng-template pTemplate="header">
        <tr class="p-col-2">
          <!-- APIヘッダーの表示 -->
          <ng-container *ngFor="let column of columnOrder">
            <th [pSortableColumn]="column.field">
              {{ column.header }}
              <p-sortIcon [field]="column.field"></p-sortIcon>
            </th>
          </ng-container>
          <!-- 操作ヘッダーの表示 -->
          <th>
            <p>操作</p>
          </th>
        </tr>
      </ng-template>

      <!-- 一覧画面ボディ表示-->
      <ng-template pTemplate="body" let-generateSearchItems>
        <!-- 削除日付が存在する場合、行をグレーアウト -->
        <tr
          [ngClass]="{
            'row-accessories': generateSearchItems['delete_datetime'] != ''
          }"
        >
          <!-- 一覧表示-->
          <ng-container *ngFor="let column of columnOrder; index as i">
            <!-- 一覧項目値表示(詳細画面遷移項目) -->
            <td *ngIf="0 == i; else hideContent">
              <label
                (click)="
                  detail(
                    generateSearchItems[column.field],
                    generateSearchItems['create_department_code']
                  )
                "
              >
                <u>{{ generateSearchItems[column.field] }}</u>
              </label>
            </td>
            <!-- 一覧項目値表示 -->
            <ng-template #hideContent>
              <td [ngSwitch]="column?.input_type">
                <span *ngSwitchCase="'NUMBER'">
                  {{ generateSearchItems[column.field] | number }}
                </span>
                <span *ngSwitchDefault>
                  {{ generateSearchItems[column.field] }}
                </span>
              </td>
            </ng-template>
          </ng-container>
          <!-- 操作表示 -->
          <td
            [ngClass]="{
              'no-button': !(
                loginUser.department_code ==
                generateSearchItems['create_department_code']
              )
            }"
          >
            <!-- 編集ボタン -->
            <!-- ログインユーザの所属組織と食品マスタ登録組織コードが同一の場合 または
              特権ユーザ(組織レベルが「1:管理」& 組織種別が「9:その他」)の場合 かつ 削除データでない場合、表示-->
            <button
              pButton
              (click)="edit(generateSearchItems[columnOrder[0].field])"
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success p-mr-2"
              pTooltip="編集"
              tooltipPosition="bottom"
              *ngIf="
                (loginUser.department_code ==
                  generateSearchItems['create_department_code'] ||
                  (loginUser.department_level == 1 &&
                    loginUser.department_type == 9)) &&
                generateSearchItems['delete_datetime'] == ''
              "
            ></button>
            <!-- 複製ボタン -->
            <!-- ログインユーザの所属組織と食品マスタ登録組織コードが同一の場合 または
              特権ユーザ(組織レベルが「1:管理」& 組織種別が「9:その他」)の場合、表示-->
            <button
              pButton
              (click)="duplicate(generateSearchItems[columnOrder[0].field])"
              icon="pi pi-clone"
              class="p-button-rounded p-button-info p-mr-2"
              pTooltip="複製"
              tooltipPosition="bottom"
              *ngIf="
                loginUser.department_code ==
                  generateSearchItems['create_department_code'] ||
                (loginUser.department_level == 1 &&
                  loginUser.department_type == 9)
              "
            ></button>
            <!-- 削除ボタン -->
            <!-- ログインユーザの所属組織と食品マスタ登録組織コードが同一の場合 または
              特権ユーザ(組織レベルが「1:管理」& 組織種別が「9:その他」)の場合 かつ 削除データでない場合、表示-->
            <button
              pButton
              (click)="delete(generateSearchItems[columnOrder[0].field])"
              icon="pi pi-trash"
              class="p-button-rounded p-button-danger"
              pTooltip="削除"
              tooltipPosition="bottom"
              *ngIf="
                (loginUser.department_code ==
                  generateSearchItems['create_department_code'] ||
                  (loginUser.department_level == 1 &&
                    loginUser.department_type == 9)) &&
                generateSearchItems['delete_datetime'] == ''
              "
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- 検索画面-->
  <mat-drawer #search class="search-sidenav" mode="side">
    <!-- 検索画面非表示-->
    <button
      type="button"
      pButton
      icon="pi pi-arrow-left"
      (click)="search.toggle()"
      class="p-mr-2"
    ></button>

    <!-- 検索画面[検索項目生成(アイテムアダプター)]-->
    <app-generate-search
      [searchEndPoint]="searchEndPoint"
      [searchTemplateId]="searchTemplateId"
      (generateSearchInformation)="searchResult($event)"
    ></app-generate-search>
  </mat-drawer>
</mat-drawer-container>

<!-- 詳細画面 -->
<app-item-detail (reloadID)="searchReplacement($event)"></app-item-detail>

<!-- 登録画面[入力項目生成(アイテムアダプター)]-->
<app-generate-input (reloadID)="searchReplacement($event)"></app-generate-input>

<!-- 削除ダイアログ-->
<app-delete-dialog (reloadID)="searchReplacement($event)"></app-delete-dialog>

<!-- Toastメッセージ表示 -->
<p-toast position="top-center"></p-toast>
